const useColumns = () => {
  const columns = [
    { Header: "ลำดับ", accessor: "id", showInFilter: false },
    { Header: "ชื่อสิทธิ์", accessor: "name", showInFilter: false },
    { Header: "วันที่สร้าง", accessor: "created_date", showInFilter: false },
    { Header: "วันที่แก้ไข", accessor: "updated_date", showInFilter: false },
  ];

  return columns;
};

export default useColumns;
